import { render } from "./pickImage.vue?vue&type=template&id=7bed1bd3&scoped=true"
import script from "./pickImage.vue?vue&type=script&lang=ts"
export * from "./pickImage.vue?vue&type=script&lang=ts"

import "./pickImage.vue?vue&type=style&index=0&id=7bed1bd3&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7bed1bd3"

export default script